import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    imports: [
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./error.component.scss']
})
export class ErrorComponent {

    constructor() {
    }

    retry() {
        window.location.reload();
    }
}
